import moment from 'moment';

import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';

export function getCellTitle(cellValue: any, titleKey?: string, dataType?: string) {
    if (titleKey && cellValue && typeof cellValue === 'object') {
        return cellValue[titleKey];
    }

    if (dataType === 'timestamp') {
        return moment
            .unix(cellValue)
            .format(FormattedTimestamp.formats.shortDayMonthYearWithAtTime);
    }

    if (typeof cellValue === 'string' || typeof cellValue === 'number') {
        return cellValue;
    }

    return undefined;
}
